'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var objectWithoutProperties = require('../../objectWithoutProperties-aa43106a.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject$1;
var gridTemplateColumns = xstyledStyledComponents_es.style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = xstyledStyledComponents_es.style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = xstyledStyledComponents_es.style({
  prop: 'gridTemplateAreas'
});
var columnGap = xstyledStyledComponents_es.style({
  prop: 'columnGap',
  themeGet: xstyledStyledComponents_es.getSpace
});
var rowGap = xstyledStyledComponents_es.style({
  prop: 'rowGap',
  themeGet: xstyledStyledComponents_es.getSpace
});
var justifyItems = xstyledStyledComponents_es.style({
  prop: 'justifyItems'
});
var alignItems = xstyledStyledComponents_es.style({
  prop: 'alignItems'
});
var placeItems = xstyledStyledComponents_es.style({
  prop: 'placeItems'
});
var alignContent = xstyledStyledComponents_es.style({
  prop: 'alignContent'
});
var justifyContent = xstyledStyledComponents_es.style({
  prop: 'justifyContent'
});
var placeContent = xstyledStyledComponents_es.style({
  prop: 'placeContent'
});
var paddingBottom = xstyledStyledComponents_es.style({
  prop: 'paddingBottom',
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingLeft = xstyledStyledComponents_es.style({
  prop: 'paddingLeft',
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingRight = xstyledStyledComponents_es.style({
  prop: 'paddingRight',
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingTop = xstyledStyledComponents_es.style({
  prop: 'paddingTop',
  themeGet: xstyledStyledComponents_es.getSpace
});
var styleProps$1 = xstyledStyledComponents_es.compose(gridTemplateColumns, gridTemplateRows, gridTemplateAreas, columnGap, rowGap, justifyItems, alignItems, placeItems, justifyContent, alignContent, placeContent, paddingBottom, paddingLeft, paddingRight, paddingTop);
var SystemGrid = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'div', styleProps$1);
var GridWrapper = xstyledStyledComponents_es.styled(SystemGrid)(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: grid;\n  width: 100%;\n  ", "\n"])), styleProps$1);
GridWrapper.displayName = 'GridWrapper';

var _templateObject;
var gridColumnStart = xstyledStyledComponents_es.style({
  prop: 'gridColumnStart'
});
var gridColumnEnd = xstyledStyledComponents_es.style({
  prop: 'gridColumnEnd'
});
var gridRowStart = xstyledStyledComponents_es.style({
  prop: 'gridRowStart'
});
var gridRowEnd = xstyledStyledComponents_es.style({
  prop: 'gridRowEnd'
});
var gridColumn = xstyledStyledComponents_es.style({
  prop: 'gridColumn'
});
var gridRow = xstyledStyledComponents_es.style({
  prop: 'gridRow'
});
var gridArea = xstyledStyledComponents_es.style({
  prop: 'gridArea'
});
var justifySelf = xstyledStyledComponents_es.style({
  prop: 'justifySelf'
});
var alignSelf = xstyledStyledComponents_es.style({
  prop: 'alignSelf'
});
var styleProps = xstyledStyledComponents_es.compose(gridColumnStart, gridColumnEnd, gridRowStart, gridRowEnd, gridColumn, gridRow, gridArea, justifySelf, alignSelf);
var SystemGridChild = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'div', styleProps);
var GridChildWrapper = xstyledStyledComponents_es.styled(SystemGridChild)(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  ", "\n"])), styleProps);
GridChildWrapper.displayName = 'GridChildWrapper';

function Grid(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(GridWrapper, props, children);
}
function GridChild(_ref2) {
  var children = _ref2.children,
      props = objectWithoutProperties.objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(GridChildWrapper, props, children);
}
Grid.defaultProps = {
  children: null,
  gridTemplateColumns: {
    xs: 'repeat(4, minmax(0, 1fr))',
    md: 'repeat(6, minmax(0, 1fr))',
    lg: 'repeat(12, minmax(0, 1fr))'
  },
  gridTemplateRows: null,
  gridTemplateAreas: null,
  columnGap: {
    xs: '4x',
    md: '8x'
  },
  rowGap: null,
  justifyItems: null,
  alignItems: null,
  placeItems: null,
  justifyContent: null,
  alignContent: null,
  placeContent: null,
  paddingBottom: null,
  paddingLeft: {
    xs: '6x',
    md: '12x',
    lg: 56
  },
  paddingRight: {
    xs: '6x',
    md: '12x',
    lg: 56
  },
  paddingTop: null
};
GridChild.defaultProps = {
  children: null,
  gridColumnStart: null,
  gridColumnEnd: null,
  gridRowStart: null,
  gridRowEnd: null,
  gridColumn: null,
  gridRow: null,
  gridArea: null,
  justifySelf: null,
  alignSelf: null
};
Grid.propTypes = {
  alignContent: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  alignItems: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  children: index.PropTypes.oneOfType([index.PropTypes.node, index.PropTypes.func]),
  columnGap: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  gridTemplateAreas: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridTemplateColumns: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridTemplateRows: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  justifyContent: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  justifyItems: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  paddingBottom: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingLeft: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingRight: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingTop: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  placeContent: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  placeItems: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  rowGap: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object])
};
GridChild.propTypes = {
  alignSelf: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  children: index.PropTypes.oneOfType([index.PropTypes.node, index.PropTypes.func]),
  gridArea: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridColumn: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridColumnEnd: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridColumnStart: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridRow: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridRowEnd: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  gridRowStart: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  justifySelf: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object])
};
Grid.Child = GridChild;
Grid.Child.displayName = 'Grid.Child';

exports.Grid = Grid;
exports.GridChild = GridChild;
exports.default = Grid;
//# sourceMappingURL=Grid.js.map
